import type { DetailsPanelSpaceAdminQuery } from '../queries/__types__/DetailsPanelSpaceAdminQuery';

export const normalizeSpaceAdminData = (data?: DetailsPanelSpaceAdminQuery) => ({
	isCurrentUserSpaceAdmin: data?.space?.currentUser.isAdmin ?? false,
});
